// Shared provider instances to avoid creating multiple connections
import { ethers } from 'ethers';

// Singleton mainnet provider - reuse this across the app
let mainnetProvider = null;

export const getMainnetProvider = () => {
  if (!mainnetProvider) {
    mainnetProvider = new ethers.providers.JsonRpcProvider(
      process.env.REACT_APP_ETH_MAINNET_RPC_URL
    );
    // Disable automatic network detection to reduce RPC calls
    mainnetProvider.pollingInterval = 60000; // Poll every 60 seconds instead of default
  }
  return mainnetProvider;
};

// Singleton Base provider
let baseProvider = null;

export const getBaseProvider = () => {
  if (!baseProvider) {
    const rpcUrl = process.env.REACT_APP_RPC_URL || '';
    baseProvider = new ethers.providers.JsonRpcProvider(rpcUrl);
    baseProvider.pollingInterval = 15000; // Poll every 15 seconds
  }
  return baseProvider;
};

// Singleton Etherlink provider (optional — returns null if RPC not configured)
let etherlinkProvider = null;

export const getEtherlinkProvider = () => {
  const rpcUrl = process.env.REACT_APP_ETHERLINK_RPC_URL;
  if (!rpcUrl) return null;
  if (!etherlinkProvider) {
    etherlinkProvider = new ethers.providers.JsonRpcProvider(rpcUrl);
    etherlinkProvider.pollingInterval = 15000;
  }
  return etherlinkProvider;
};